export default __webpack_public_path__ + "static/media/Delete-pic.89e60851.svg";